export const PROGRAM_TYPES = [
  { id: "print", label: "Print", enabled: true },
  { id: "digital", label: "Digital", enabled: false },
  { id: "html", label: "HTML", enabled: false },
];
